/** Runs `fn` once webflow.js has initialised (IX3 etc.). Before webflow.js loads, `window.Webflow` is the queue it drains. */
export const onWebflowReady = (fn: () => void) => {
  const queue: Array<() => void> = [];
  (window.Webflow ||= queue).push(fn);
};
